module.exports = __webpack_public_path__ + "static/media/super_admin_logo.c45ac3b2.svg";